<template>
  <section class="about-us-container" ref="aboutUsContainer">
    <div class="about-us-hero">
      <h1 class="about-us-title">About Us</h1>
      <p class="about-us-subtitle">PT Dumons Cat Indonesia &middot; Boyolali, Jawa Tengah</p>
    </div>

    <div class="about-us-body">
      <div class="about-us-company">
        <div class="about-us-image-wrapper" @click="openModal">
          <img class="about-us-image" :src="companyImage" alt="Pabrik Dumons">
          <span class="about-us-image-hint">Lihat foto</span>
        </div>
        <div class="about-us-company-text">
          <p class="about-us-eyebrow">Tentang Perusahaan</p>
          <h2 class="about-us-heading">Manufaktur coating cat dari Boyolali</h2>
          <p class="about-us-description">
            Perusahaan kami yang berbasis di Boyolali, Jawa Tengah, adalah manufaktur terkemuka di bidang coating cat dan sejenisnya. Kami berkomitmen untuk menghadirkan produk dengan kualitas terbaik di kelasnya, namun tetap menawarkan harga yang terjangkau.
          </p>
          <p class="about-us-description">
            Dengan memanfaatkan teknologi mutakhir dari Jerman dan hanya menggunakan bahan-bahan pilihan, kami memastikan bahwa setiap produk yang kami hasilkan memenuhi standar tinggi yang kami tetapkan. Beragam varian produk kami dirancang untuk memenuhi kebutuhan beragam konsumen, mulai dari para profesional hingga pengguna awam, dengan jaminan kemudahan penggunaan dan performa yang andal.
          </p>
        </div>
      </div>

      <div class="about-us-highlights">
        <div v-for="(highlight, index) in highlights" :key="index" class="about-us-highlight">
          <p class="about-us-highlight-title">{{ highlight.title }}</p>
          <p class="about-us-highlight-text">{{ highlight.text }}</p>
        </div>
      </div>

      <div class="about-us-vision">
        <p class="about-us-eyebrow about-us-eyebrow-light">Our Vision</p>
        <p class="about-us-vision-text">
          Menjadi pemimpin industri coating cat yang terpercaya dan inovatif di pasar nasional, dengan terus menghadirkan solusi coating berkualitas tinggi yang ramah pengguna dan mendukung kemajuan teknologi.
        </p>
      </div>

      <div class="about-us-mission">
        <p class="about-us-eyebrow">Our Mission</p>
        <div class="about-us-mission-grid">
          <div v-for="(item, index) in mission" :key="index" class="about-us-mission-card">
            <span class="about-us-mission-number">{{ String(index + 1).padStart(2, '0') }}</span>
            <p class="about-us-mission-title">{{ item.tagline }}</p>
            <p class="about-us-mission-description">{{ item.description }}</p>
          </div>
        </div>
      </div>

      <div class="about-us-cta">
        <p class="about-us-cta-text">Temukan coating yang tepat untuk kebutuhan Anda</p>
        <div class="about-us-cta-buttons">
          <router-link to="/productList" class="about-us-button about-us-button-primary">Lihat Produk</router-link>
          <router-link to="/contactUs" class="about-us-button">Hubungi Kami</router-link>
        </div>
      </div>
    </div>
  </section>
  <ImageModal v-if="showModal" :image-url="companyImage" @closeModal="closeModal"></ImageModal>
</template>

<script>
import ImageModal from "@/components/modal/image_modal/ImageModal.vue";

export default {
  name: 'AboutUsPage',
  components: {ImageModal},
  data () {
    return {
      companyImage: 'https://raw.githubusercontent.com/hanifsyahsn/dumons-asset/refs/heads/main/images/WhatsApp%20Image%202024-10-13%20at%2022.07.55.jpeg',
      showModal: false,
      highlights: [
        {title: 'Teknologi Jerman', text: 'Proses produksi dengan teknologi mutakhir'},
        {title: 'Bahan Pilihan', text: 'Hanya menggunakan bahan baku terbaik'},
        {title: 'Harga Terjangkau', text: 'Kualitas terbaik di kelasnya'},
        {title: 'Untuk Semua', text: 'Dari profesional hingga pengguna awam'}
      ],
      mission: [
        {tagline: 'Mengutamakan Kualitas', description: 'Memproduksi coating dengan standar tinggi menggunakan teknologi Jerman dan bahan pilihan terbaik untuk memastikan kepuasan pelanggan.'},
        {tagline: 'Inovasi Berkelanjutan', description: 'Mengembangkan produk yang sesuai dengan kebutuhan dan tren terkini, serta memperkenalkan inovasi yang meningkatkan pengalaman pengguna.'},
        {tagline: 'Pelayanan Pelanggan', description: 'Memberikan dukungan penuh kepada konsumen dari berbagai kalangan, memastikan produk mudah digunakan dan efektif.'},
        {tagline: 'Kompetitif dalam Harga', description: 'Menawarkan solusi coating dengan harga yang terjangkau tanpa mengorbankan kualitas.'},
        {tagline: 'Tanggung Jawab Sosial', description: 'Berkontribusi pada pembangunan komunitas lokal dan menjalankan proses manufaktur yang ramah lingkungan.'}
      ]
    }
  },
  mounted() {
    setTimeout(() => {
      this.$refs.aboutUsContainer.setAttribute('active', '')
    }, 0)
  },
  methods: {
    openModal() {
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    }
  }
}
</script>

<style scoped>

.about-us-container {
  opacity: 0;
  width: 100%;
  min-width: 320px;
  background-color: var(--light-grey);
  transition: opacity 500ms ease;
}

.about-us-container[active] {
  opacity: 1;
}

.about-us-hero {
  width: 100%;
  min-height: 190px;
  padding: 64px 16px 28px;
  box-sizing: border-box;
  background-color: black;
  border-bottom: 10px solid var(--dodger-blue);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  @media (--large) {
    min-height: 240px;
    padding-top: 72px;
  }
}

.about-us-title {
  font-family: "Bebas Neue", sans-serif;
  font-weight: 400;
  font-size: 40px;
  line-height: 1;
  color: var(--white);
  @media (--large) {
    font-size: 56px;
  }
}

.about-us-subtitle {
  margin-top: 8px;
  color: var(--shaddow-white);
  font-size: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
  @media (--large) {
    font-size: 16px;
  }
}

.about-us-body {
  width: 100%;
  max-width: var(--page-max-width);
  margin: 0 auto;
  padding: 32px 16px 48px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 32px;
  @media (--medium) {
    padding: 48px 24px 64px;
    gap: 48px;
  }
  @media (--large) {
    padding: 64px 48px 80px;
  }
}

.about-us-eyebrow {
  font-family: "Bebas Neue", sans-serif;
  font-size: 18px;
  letter-spacing: 2px;
  color: var(--corn-flower-blue);
  @media (--large) {
    font-size: 20px;
  }
}

.about-us-eyebrow-light {
  color: var(--dodger-blue);
}

.about-us-company {
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media (--large) {
    flex-direction: row;
    align-items: center;
    gap: 48px;
  }
}

.about-us-image-wrapper {
  position: relative;
  flex: 0 0 auto;
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: 12px;
  overflow: hidden;
  background-color: var(--black);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  @media (--large) {
    width: 46%;
  }
}

.about-us-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  transition: transform 600ms ease;
}

.about-us-image-hint {
  position: absolute;
  right: 12px;
  bottom: 12px;
  padding: 4px 10px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.6);
  color: var(--white);
  font-family: "Bebas Neue", sans-serif;
  font-size: 14px;
  letter-spacing: 1px;
  cursor: pointer;
}

@media (hover: hover) {
  .about-us-image-wrapper:hover .about-us-image {
    transform: scale(1.04);
  }
}

.about-us-company-text {
  flex: 1 1 auto;
}

.about-us-heading {
  margin-top: 4px;
  margin-bottom: 16px;
  font-family: "Bebas Neue", sans-serif;
  font-weight: 400;
  font-size: 30px;
  line-height: 1.1;
  color: var(--black);
  @media (--large) {
    font-size: 40px;
  }
}

.about-us-description {
  font-size: 16px;
  line-height: 1.6;
  color: var(--black);
  & + & {
    margin-top: 12px;
  }
  @media (--large) {
    font-size: 17px;
  }
}

.about-us-highlights {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  @media (--large) {
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }
}

.about-us-highlight {
  padding: 16px;
  border-radius: 10px;
  background-color: var(--white);
  border-top: 4px solid var(--dodger-blue);
  @media (--large) {
    padding: 20px;
  }
}

.about-us-highlight-title {
  font-family: "Bebas Neue", sans-serif;
  font-size: 22px;
  line-height: 1.1;
  color: var(--black);
  @media (--large) {
    font-size: 26px;
  }
}

.about-us-highlight-text {
  margin-top: 4px;
  font-size: 14px;
  line-height: 1.4;
  color: #555;
}

.about-us-vision {
  padding: 28px 20px;
  border-radius: 12px;
  background-color: black;
  border-left: 6px solid var(--dodger-blue);
  @media (--large) {
    padding: 48px 56px;
  }
}

.about-us-vision-text {
  margin-top: 8px;
  font-size: 20px;
  line-height: 1.5;
  font-weight: 300;
  color: var(--white);
  @media (--large) {
    font-size: 28px;
  }
}

.about-us-mission-grid {
  margin-top: 12px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  @media (--medium) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
  @media (--large) {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
}

.about-us-mission-card {
  padding: 20px;
  border-radius: 10px;
  background-color: var(--white);
  transition: transform 200ms ease, box-shadow 200ms ease;
}

@media (hover: hover) {
  .about-us-mission-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
  }
}

.about-us-mission-number {
  font-family: "Bebas Neue", sans-serif;
  font-size: 36px;
  line-height: 1;
  color: var(--dodger-blue);
}

.about-us-mission-title {
  margin-top: 8px;
  font-family: "Bebas Neue", sans-serif;
  font-size: 22px;
  color: var(--black);
}

.about-us-mission-description {
  margin-top: 6px;
  font-size: 15px;
  line-height: 1.5;
  color: #444;
}

.about-us-cta {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 28px 20px;
  border-radius: 12px;
  background-color: var(--dodger-blue);
  text-align: center;
  @media (--large) {
    flex-direction: row;
    justify-content: space-between;
    padding: 32px 48px;
    text-align: left;
  }
}

.about-us-cta-text {
  font-family: "Bebas Neue", sans-serif;
  font-size: 26px;
  line-height: 1.1;
  color: black;
  @media (--large) {
    font-size: 32px;
  }
}

.about-us-cta-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}

.about-us-button {
  display: inline-block;
  padding: 10px 22px;
  border-radius: 6px;
  border: 2px solid black;
  font-family: "Bebas Neue", sans-serif;
  font-size: 20px;
  letter-spacing: 1px;
  color: black;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 200ms ease, color 200ms ease, transform 200ms ease;
  &:active {
    transform: scale(0.95);
  }
}

.about-us-button-primary {
  background-color: black;
  color: var(--white);
}

@media (hover: hover) {
  .about-us-button:hover {
    background-color: var(--white);
    border-color: var(--white);
    color: black;
  }
}

</style>
